removed.factory('RemovedOldDataResource', ['$resource', function ($resource) {
    return $resource('/removed-old-data/:action/:dir/:type/:name/:year', {action: '@action', dir: '@dir', type: '@type', name: '@name', year: '@year'}, {});
}]);